<template src="./RiskBadge.html"></template>

<script>
export default {
  name: "RiskBadge",
};
</script>

<style lang="scss" src="./RiskBadge.scss"></style>
